import { GridRowId, GridValidRowModel } from '@mui/x-data-grid-premium'
import { createContext, useContext } from 'react'

export type DragDropGridContextType = {
  // Use to track rows that are being dragged
  draggingRows: GridRowId[],
  setDraggingRows: (rowIds: GridRowId[]) => void,

  // Callback function when one or more rows are dropped after the target row
  // TODO: Update onGridRowsDrop to accept not only the row data, but also the grid id
  onGridRowsDrop?: (sourceData: GridValidRowModel[], targetData: GridValidRowModel) => void,
}

export const DragDropGridContext = createContext<DragDropGridContextType>({
  draggingRows: [],
  setDraggingRows: () => { },
  onGridRowsDrop: () => { },
})

// Used to access context state
export const useDragDropGridContext = () => {
  const context = useContext(DragDropGridContext)

  if (context === undefined) {
    throw new Error(
      'useDragDropGridContext must be used within a DragDropGridContext.Provider',
    )
  }

  return context
}
